class HybridConfig {
    get(key, defaultValue) {
        const keyArray = key.split(".");
        let currentContext = this.getConfig();
        for (const currentKey of keyArray) {
            if (currentContext[currentKey] != null) {
                currentContext = currentContext[currentKey];
            } else {
                return defaultValue;
            }
        }

        return currentContext;
    }

    auditScriptlets() {
        return this.get("auditing", false);
    }

    set(key, value) {
        const parts = key.split(".");
        const final = parts.pop();
        let curr = this.getConfig();
        for (let i = 0; i < parts.length; i++) {
            const p = parts[i];
            if (!curr.hasOwnProperty(p)) {
                console.warn("CONFIG", `container '${parts.slice(0, i + 1).join(".")}' doesn't exist`);
                curr[p] = {};
            }
            curr = curr[p];
        }
        if (!curr.hasOwnProperty(final)) {
            console.warn("CONFIG", `key '${key}' doesn't exist`);
        }
        curr[final] = value;
    }

    setConfig(config) {
        this.config = config;
    }

    getConfig() {
        if (this.config != null) {
            return this.config;
        } else if (window.HybridConfig != null) {
            return window.HybridConfig;
        } else {
            return {};
        }
    }
}

export default new HybridConfig();



// WEBPACK FOOTER //
// ./app/lib/HybridConfig.js